import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { useTranslation } from 'react-i18next'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import SidebarMenu from '../sidebar/SidebarMenu'
import { useMenuItems } from '../useMenuItems'
import styles from './MobileMenu.module.scss'

export const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { activeMenuItem, menuItems } = useMenuItems()
  const { t } = useTranslation()

  const toggleModal = () => {
    setIsOpen(!isOpen)
    document.body.style.overflow = isOpen ? 'unset' : 'hidden'
    const root = document.getElementById('root')
    if (root) {
      root.style.overflow = isOpen ? 'unset' : 'hidden'
    }
  }

  return (
    <div className={styles.wrapper}>
      {isOpen && <div className={styles.mask} onClick={toggleModal}></div>}
      <div className={styles.menuTrigger} onClick={toggleModal}>
        <div className={styles.triggerIconWrapper}>
          {menuItems[activeMenuItem] && (
            <div className={styles.triggerIcon}>
              <FontAwesomeIcon
                icon={menuItems[activeMenuItem].icon as IconProp}
              />
            </div>
          )}
          <span className={styles.triggerText}>
            {t(menuItems[activeMenuItem]?.text)}
          </span>
          <div className={styles.triggerIcon}>
            <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>
      {isOpen && (
        <div className={styles.menuWrapper} onClick={toggleModal}>
          <SidebarMenu siderIsCollapsed={false} className={styles.menu} />
        </div>
      )}
    </div>
  )
}
